import React, { useState } from 'react';
import { connect } from 'react-redux';

import StatementModal from './statementModal';

const Footer = ({ shouldDisplay = false }) => {
  const [activeStatement, setActiveStatement] = useState(null);
  const fullYear = new Date().getFullYear();

  const openStatement = (key) => () => setActiveStatement(key);
  const closeStatement = () => setActiveStatement(null);

  return (
    <>
      <div
        className="app-footer"
        style={{ display: shouldDisplay ? 'block' : 'none' }}
      >
        <div className="boder-top" />
        <div className="statement-link">
          {/* <MainLink to={genRef('policy')}>Privacy Statement</MainLink>
           */}
          <a
            // href="https://privacyhub.pwc.com/us/en/m-a-gateway/privacy-policy.html"
            href="https://www.pwc.com/us/en/site/privacy.html"
            target="__blank"
          >
            Privacy Statement
          </a>
        </div>

        {/* <div className="statement-link">
        <MainLink to={genRef('cookie')}>Cookie Statement</MainLink>
      </div> */}

        <div className="statement-link">
          <span className="main-link" onClick={openStatement('terms')}>
            Terms of Use
          </span>
        </div>
        <div className="statement-link">
          <span className="main-link" onClick={openStatement('disclaimer')}>
            Project Disclaimer
          </span>
        </div>
        <p>
          © {fullYear} PwC. All rights reserved. PwC refers to the PwC network
          and/or more of its member firms, each of which is a separate legal
          entity.Please see{' '}
          {/* <span
            onClick={() => (window.location = 'https://www.pwc.com/structure', '_blank')}
          >
            www.pwc.com/structure
          </span> */}
          
          <a
            href="https://www.pwc.com/structure"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.pwc.com/structure
          </a>

          {' '}
          for further details.
        </p>
        {/* <p>
        Confidential Information for the sole benefit and use of PwC’s client,
        which should be read in conjunction with the following{' '}
        <MainLink to="/privacy">statement</MainLink>.
        
        <a
          // href="https://privacyhub.pwc.com/us/en/m-a-gateway/privacy-policy.html"
          href="https://www.pwc.com/us/en/site/privacy.html"
          target="__blank"
        >
          statement
        </a>
      </p> */}
        <p>
          Confidential Information for the sole benefit and use of PwC’s client,
          which should be read in conjunction with the Privacy Statement.
        </p>
        <p>
          This application may include information generated in an automated
          manner using third-party data sets and generative AI and may not
          always be accurate and does not constitute professional advice. This
          application is not for the use, benefit, or reliance of any other
          party and PwC disclaims all liability relating to use of the
          information generated by this application, including decisions,
          actions, or omissions taken or not taken in reliance on the
          information.
        </p>
      </div>

      <StatementModal
        visible={!!activeStatement}
        statementKey={activeStatement}
        onClose={closeStatement}
      />
    </>
  );
};

const mapStateToProps = ({ common }) => ({
  shouldDisplay: common.shouldShowStatementFooter,
});

export default connect(mapStateToProps)(Footer);
